module.exports = __webpack_public_path__ + "img/symbol_12.44d012fb.png";